const routeReducer = (state = {}, action) => {
	switch (action.type) {
		case "SET_ROUTE":
			return action.path || state;
		default:
			return state;
	}
};
export default routeReducer;
